<template>
  <a-modal
    title="批量分配分包单位"
    :visible="visible"
    @ok="handleOk"
    width="auto"
    centered
    :keyboard="false"
    :maskClosable="false"
    @cancel="handleCancel"
    okText="保存"
    :getContainer="getContainer"
  >
    <div class="content">
      <div class="content1">
        <FormItem label="分包单位">
          <a-select
            size="large"
            show-search
            style="width: 100%"
            placeholder="请选择所属单位"
            option-filter-prop="children"
            :filter-option="filterOption"
            v-model="company_id"
            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
          >
            <a-select-option :value="v.id" v-for="v in company_arr" :key="v.id">
              {{ v.name }}
            </a-select-option>
          </a-select>
        </FormItem>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { handleFileUpload, saveExcel } from "@/utils/os";
import { personFileBatch } from "@/utils/exportFile";
import { isDateOrDateTime, excelTimeFormat } from "@/utils/util";
import SelectFile from "@/components/SelectFile/index";
import { companyAll } from "@/request/company";
import { batchAdd } from "@/request/person";
import FormItem from "@/components/FormItem/index";
export default {
  components: { SelectFile, FormItem },
  data() {
    return {
      visible: false,
      company_id: undefined,
      company_arr: [],
    };
  },
  methods: {
    init() {
      this.visible = true;
      companyAll().then((res) => {
        this.company_arr = res.data;
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleOk() {
      if (!this.company_id) return this.$message.warning("请选择分包单位");
      this.$emit("confirm", this.company_id);
      this.handleCancel()
    },
    handleCancel() {
      this.visible = false;
      this.company_id = undefined;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style scoped>
.downloadFile {
  font-size: 12px;
  color: #011733;
  margin-top: 15px;
  cursor: pointer;
  display: inline-block;
}
.content {
  display: flex;
}
.content1 {
  width: 100%;
  min-width: 400px;
  max-width: 400px;
}
.content2 {
  width: 300px;
  margin-left: 20px;
  max-height: 80vh;
  overflow-y: auto;
}

.description {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.left {
  width: 80%;
}
.del {
}
</style>